<div class="bl-block-module bl-font-color--base bl-padding--16 bl-padding-lg--48 bl-margin--24 bl-margin-lg--0 bl-margin-y-lg--48">
  <header class="bl-text-align--center bl-margin-bottom--48">
    <h1 class="bl-text-style--display-3">
      {{ title }}
    </h1>
    <ng-content />
    <p class="bl-text-style--default-text-1">
      {{ description }}
    </p>
  </header>
  @if (showEmail || showAddress || showPhone) {
  <dx-content-messaging-info
    [showAddress]="showAddress"
    [showPhone]="showPhone"
    [showEmail]="showEmail"
    [addressLabel]="addressLabel"
    [emailLabel]="emailLabel"
    [phoneLabel]="phoneLabel"
  />
  }
</div>
